import { countryToAlpha2 } from 'country-to-iso';
import { DEFAULT_TMS_FORMAT, getLocale, getLocales } from '../constants';
import { isGBRRegion } from './domain';
export const localizeMoney = (numberObject, locale, args) => new Intl.NumberFormat(locale, Object.assign({ style: 'currency', currency: numberObject.currency, currencyDisplay: 'code', maximumFractionDigits: 2 }, args)).format(numberObject.value);
export const localizePercent = (value, { currentLocale = 'de-DE', options = {} } = {}) => new Intl.NumberFormat(currentLocale, Object.assign({ style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 2 }, options)).format(value);
export const getCountryFromAlpha3Code = (countryCode, locale) => {
    const countryAlpha2Code = countryToAlpha2(countryCode);
    const nameParser = new Intl.DisplayNames([locale.split('-')[0]], { type: 'region' });
    return countryAlpha2Code ? nameParser.of(countryAlpha2Code) : null;
};
export const getTMSFormat = (locale) => { var _a; return locale ? (_a = getLocale(locale)) === null || _a === void 0 ? void 0 : _a.tmsFormat : DEFAULT_TMS_FORMAT; };
/**
 *
 * Ensure the format of locale to be Intl compatible: de-DE
 * @param {string} locale can be any of these formats: de-de or de-DE
 * @return {string} in this format de-DE or input string in case it does not match the expected formats
 */
export const formatLocaleForIntl = (locale) => {
    // Split the locale using the "-" delimiter
    const parts = locale.split('-');
    // Check if there are at least two parts
    if (parts.length >= 2) {
        // Convert the second part to uppercase
        parts[1] = parts[1].toUpperCase();
        // Join the parts back together using "-"
        return parts.join('-');
    }
    // Return the input string as is if it doesn't contain a "-"
    return locale;
};
/**
 * Get the current user's language code in ISO1 format
 *
 * @param locale The user's locale value
 * @returns A language code in ISO1 format
 */
export const getISO1LangCodeByLocale = (locale) => {
    var _a;
    const language = (_a = getLocale(locale)) === null || _a === void 0 ? void 0 : _a.langISO1;
    if (!language)
        throw new Error(`Language is not available for this locale:${locale}`);
    else
        return language;
};
export const isDEULocale = (locale) => locale === 'de-DE';
export const isAUTLocale = (locale) => locale === 'de-AT';
export const isFRALocale = (locale) => locale === 'fr-FR';
export const isIRLLocale = (locale) => locale === 'en-IE';
export const isGBRLocale = (locale) => locale === 'en-GB';
/**
 * Returns Locale based on customer address and region
 * @param countryCode ISO3 country code
 */
export const getLocaleFromCountryCode = (countryCode) => {
    var _a;
    const countryLocale = (_a = getLocales()
        .map((l) => getLocale(l))
        .find((l) => l.iso3 === (countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLowerCase()))) === null || _a === void 0 ? void 0 : _a.key;
    return countryLocale || (isGBRRegion() ? 'en-GB' : 'en-US');
};
//# sourceMappingURL=i18n.js.map